// Interfaces
import { IBackOfficeBaseCardProps } from './interfaces'
import { IRoute } from 'routes/route.interface'

// Antd
import { Menu } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// React Router DOM
import { useHistory, useLocation } from 'react-router-dom'

// Styles
import './styles.scss'

// Mobx
import { observer } from 'mobx-react'

// Models
import { useStores } from 'models'

// Custom Hook
import { useBackOfficeRoutes } from 'hooks'

const BackOfficeBaseCard = observer(({ children, meta }: IBackOfficeBaseCardProps) => {
  // Hook
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const {
    auth: { auth_authenticatedUser },
  } = useStores()
  const { childrenRoutes } = useBackOfficeRoutes({ authenticatedUser: auth_authenticatedUser, module: meta.module })

  return (
    <div className="back-office-base-card">
      <div className="back-office-base-card-header">
        <Menu
          triggerSubMenuAction="click"
          onClick={(event: any) => history.push(event.key)}
          selectedKeys={[location.pathname]}
          mode="horizontal"
        >
          {childrenRoutes.map((route: IRoute) => (
            <Menu.Item key={route.path}>{t(route.meta.attrs?.label || '')}</Menu.Item>
          ))}
        </Menu>
      </div>
      <div className="back-office-base-card-body">{children}</div>
    </div>
  )
})

export { BackOfficeBaseCard }
